<template>
  <div class="flex flex-wrap pt-[4px]">
    <div
      class="mr-5 mb-[30px]"
      v-for="category in categories"
      :key="category.slug"
    >
      <label
        class="big-checkbox ml-[16px]"
        :for="`client-cb-${category.slug}`"
        >{{ category.name[native] }}
        <input
          class="checkbox"
          :id="`client-cb-${category.slug}`"
          type="checkbox"
          @input="(e) => inputHandler((e.target as HTMLInputElement).checked, category)"
          :checked="selectedTypes.includes(category.slug)"
        />
        <div class="checkbox-indicator"></div>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  import mixin from '@/utils/mixins/RcMixin.vue';
  import { useConfigStore, useRoadbookStore } from '@/store';

  export default defineComponent({
    mixins: [mixin],
    computed: {
      categories(): Array<any> {
        return useConfigStore().config.visitor_categories as Array<any>;
      },
      selectedTypes(): Array<string> {
        return (useRoadbookStore().metadata.visitor.type || []) as Array<any>;
      },
    },
    methods: {
      inputHandler(checked: boolean, category: any) {
        const newTypes: Array<string> = this.selectedTypes;
        if (checked) {
          if (category.slug) newTypes.push(category.slug);
        } else {
          if (category.slug) newTypes.splice(newTypes.indexOf(category.slug), 1);
        }
        useRoadbookStore().setRoadbookModifiedDate();
        useRoadbookStore().updateMetadata({
          category: 'visitor',
          field: 'type',
          value: newTypes,
        });
      },
    },
  });
</script>
